import ServerAutocompleteAdapter from '../Form/Adapter/ServerAutocomplete';

interface Props {
  name: string;
  url?: string;
  label?: string;
}

function AssociationField({ name, url, label }: Props) {
  return (
    <ServerAutocompleteAdapter
      label={label}
      multiple
      optionsUrl={url || `/api/reference/${name}`}
      name={`references.${name}`}
    />
  );
}

export default AssociationField;
